require('./context')
require('./label')
require('./boolean')
require('./check')
require('./datetime')
require('./editor')
require('./event')
require('./mask')
require('./multi-select')
require('./rate')
require('./remote-select')
require('./select')
require('./text')
require('./fake-text')
require('./textarea')
require('./addressing')
require('./numeric')
require('./photo')
require('./file')
require('./selection')
require('./selection-item')
require('./selection-all')
require('./selection-page')
require('./colorpicker')
require('./validate')
require('./validator')
require('./nullable-check')
require('./radio')
require('./new-check')
require('./group-count')
require('./errors')
require('./required')


// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/form/index.js